import React from 'react'
import { UnderLineText } from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import t from '../../../../../translations/main'

const config = utils.injectTranslation({
  id: 'ConsentsForm',
  path: 'onboarding.forms.CorporateAccount.ConsentsForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        marginTop: '16px',
        marginBottom: '16px',
      },
      content: [
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'consent1',
            dataList: [
              {
                id: 'consent1Yes',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'consent1No',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            removeLabelEllipsis: true,
            translationComponent: {u:<UnderLineText/>},
            required: true,
          },
        },
        {
          componentType: 'radioGroup',
          transformType: 'stringAndBooleanConversion',
          props: {
            name: 'consent2',
            dataList: [
              {
                id: 'consent2Yes',
                label: t('components.forms.labels.yes'),
                value: 'true',
              },
              {
                id: 'consent2No',
                label: t('components.forms.labels.no'),
                value: 'false',
              },
            ],
            removeLabelEllipsis: true,
            required: true,
          },
        },
      ],
    },
  ],
})

export default config
